'use client'

import { Header } from 'refunds/components/Header/Header'
import { RefundsContainer } from 'refunds/containers/RefundsContainer/RefundsContainer'
import { useRefundData } from 'refunds/hooks/useRefundData/useRefundData'
import { RedirectToLogin } from 'utils/RedirectToLogin/RedirectToLogin'

import styles from './RefundsPage.module.scss'

export function RefundsPage() {
	const { refundData, visibilityProps, reload } = useRefundData()

	return (
		<div className={styles.page}>
			<RedirectToLogin isGuestAllowed={false} />
			{refundData && (
				<>
					<Header />
					<div className={styles.container}>
						<RefundsContainer
							refundData={refundData}
							visibilityProps={visibilityProps}
							reloadRefundData={reload}
						/>
					</div>
				</>
			)}
		</div>
	)
}
